<template>
  <div>

    <data-table
      table-ref="tenancy-expiry-table"

      title="Tenancy Expiry"
      icon="fa fa-calendar-day"

      url="/tenancy/expiry"
      :fields="fields"

      sort-field="siteName"
      search-placeholder="Landowner, Site Name, Site Group..."

      detail-component="property-details">

      <template slot="expiry-details" slot-scope="props">
        <span v-html="formatSiteStatus(props.rowData.status)" /> - <span class="text-black">{{props.rowData.landowner}}</span> <b v-if="props.rowData.countOwners > 1"> (#{{props.rowData.countOwners}} owners)</b>
        <b class="text-primary">{{props.rowData.siteName}}</b> <small class="text-info">({{props.rowData.siteId}})</small>
        <div class="pull-right">{{formatDate(props.rowData.expiry)}} | <span :class="props.rowData.expiryDays <= 30 ? 'text-danger' : (props.rowData.expiryDays >= 31 && props.rowData.expiryDays <= 90 ? 'text-warning' : 'text-success')">{{formatFriendlyDate(props.rowData.expiry)}}</span></div>
      </template>

  </data-table>

</div>

</template>

<script>

import Vue from 'vue'

import ArrayMixins from '@/mixins/ArrayMixins'
import SiteMixins from '@/mixins/SiteMixins'

import PropertyDetails from '@/components/property/PropertyDetails'

Vue.component('property-details', PropertyDetails)

export default {
  mixins: [ArrayMixins, SiteMixins],

  props: {
    showGraph: {
      type: Boolean,
      default: true
    }
  },

  methods: {

    formatExpiry (value) {
      let cls = 'text-info'

      if (value === null) {
        cls = 'text-black'
      }

      value = Number(value)

      if (value > 365) {
        cls = 'text-success'
      }

      if (value >= 121 && value <= 365) {
        cls = 'text-primary'
      }

      if (value >= 31 && value <= 120) {
        cls = 'text-warning'
      }

      if (value <= 30) {
        cls = 'text-danger'
      }

      return '<span class="' + cls + '">' + this.formatInteger(value) + '</span>'
    }

  },



  data () {
    return {
      active: 'table',
      fields: [
        {
          name: '__sequence',
          title: '#',
          sortField: 'id'
        },
        {
          name: '__slot:expiry-details'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// ExpiryTable.vue?bc23094e